export default __webpack_public_path__ + "static/media/CCLogo.cc3d2b2e.png";